import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { Link, useHistory } from 'react-router-dom';
import { useUserContext } from '@magento/peregrine/lib/context/user';
import SectionTitle from '../common/sectionTitle';
import DimensionItem from './DimensionItem';
import { Accordion, DownArrow, RichContent, Button, QuickLinkIcon } from '../../../../../components';
import classes from './specifications.module.css';
import AdditionalFeatureItem from '../common/additionalFeaturesItem';
import Downloads from '../Downloads/downloads';
import CSPortalDetails from '../CSPortalDetails/csPortalDetails';
import openIcon from '../../../../../assets/open-button.svg';
import closeIcon from '../../../../../assets/close-button.svg';
import BulbRecommendation from '../../../../../components/Tearsheet/tearsheetPDF/bulbRecommendation';
var Specifications = forwardRef(function (props, ref) {
  var _product$items, _product$items$find, _hfLamping$selected_a, _hfLamping$selected_a2, _hf_sloped_ceiling_co, _hf_sloped_ceiling_co2, _hf_pipe_length_min$e, _hf_pipe_length_max$e, _filteredSimpleOnGrou, _hf_backplate_width$e, _hf_backplate_height$, _hf_box_weight1$enter, _hf_box_weight2$enter, _hf_box_weight3$enter, _hf_box_weight1$enter2, _hf_box_weight1$enter3, _hf_box_weight2$enter2, _hf_box_weight2$enter3, _hf_box_weight3$enter2, _hf_box_weight3$enter3, _diameter$entered_att, _joistCaution$selecte, _joistCaution$selecte2, _tabs$filter, _tabs$filter2;

  var _useState = useState(['Details', 'Lamping']),
      _useState2 = _slicedToArray(_useState, 2),
      tabs = _useState2[0],
      setTabs = _useState2[1];

  var productDetails = props.productDetails,
      customAttributes = props.customAttributes,
      weight = props.weight,
      product = props.product,
      installationSheetUrl = props.installationSheetUrl,
      configCustomAttributes = props.configCustomAttributes,
      isOutletProduct = props.isOutletProduct,
      _props$isCustomerServ = props.isCustomerServiceTeam,
      isCustomerServiceTeam = _props$isCustomerServ === void 0 ? false : _props$isCustomerServ;

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      inches = _useState4[0],
      setInches = _useState4[1];

  var _useState5 = useState(tabs[0]),
      _useState6 = _slicedToArray(_useState5, 2),
      activeTab = _useState6[0],
      setActiveTab = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      fade = _useState8[0],
      setFade = _useState8[1];

  useEffect(function () {
    setFade(true);
    setTimeout(function () {
      return setFade(false);
    }, 0);
    if (!inches) setInches(true);
  }, [activeTab]);

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isUserSignedIn = _useUserContext2[0].isSignedIn;

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth <= 991;
  var history = useHistory();
  var hfLamping = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_lamping';
  });
  var hfLed = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_led';
  });
  var hf_sloped_ceiling_code = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_sloped_ceiling';
  });
  var filteredSimpleOnGrouped = (product === null || product === void 0 ? void 0 : product.type_id) === 'grouped' && (product === null || product === void 0 ? void 0 : (_product$items = product.items) === null || _product$items === void 0 ? void 0 : (_product$items$find = _product$items.find(function (prod) {
    var _prod$product;

    return (prod === null || prod === void 0 ? void 0 : (_prod$product = prod.product) === null || _prod$product === void 0 ? void 0 : _prod$product.__typename) === 'SimpleProduct';
  })) === null || _product$items$find === void 0 ? void 0 : _product$items$find.product);
  var specValues = [];
  var hfBulbType1 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_bulb_type1';
  });
  var hfBulbWatt1 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_bulb_watt1';
  });

  if (hfLamping !== null && hfLamping !== void 0 && (_hfLamping$selected_a = hfLamping.selected_attribute_options) !== null && _hfLamping$selected_a !== void 0 && (_hfLamping$selected_a2 = _hfLamping$selected_a.attribute_option[0]) !== null && _hfLamping$selected_a2 !== void 0 && _hfLamping$selected_a2.label.includes('FLU')) {
    var _hf_socket_type_fluor, _hf_socket_type_fluor2, _hf_bulb_type1_fluore, _hf_bulb_type1_fluore2, _hf_voltage_fluoresce, _hf_voltage_fluoresce2, _hf_socket_qpa1_fluor, _hf_socket_qpa1_fluor2;

    /*
        Socket: Fluorescent
        Bulb:   T-5 fluorescent, 21W Max
        Voltage:    120/277
        Number of Bulbs:    1 (not included)
    */
    var hf_socket_type_fluorescent = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_socket_type_fluorescent';
    });

    if (hf_socket_type_fluorescent !== null && hf_socket_type_fluorescent !== void 0 && (_hf_socket_type_fluor = hf_socket_type_fluorescent.selected_attribute_options) !== null && _hf_socket_type_fluor !== void 0 && (_hf_socket_type_fluor2 = _hf_socket_type_fluor.attribute_option[0]) !== null && _hf_socket_type_fluor2 !== void 0 && _hf_socket_type_fluor2.label) {
      var _hf_socket_type_fluor3, _hf_socket_type_fluor4;

      specValues.push({
        label: 'Socket',
        value: (_hf_socket_type_fluor3 = hf_socket_type_fluorescent.selected_attribute_options) === null || _hf_socket_type_fluor3 === void 0 ? void 0 : (_hf_socket_type_fluor4 = _hf_socket_type_fluor3.attribute_option[0]) === null || _hf_socket_type_fluor4 === void 0 ? void 0 : _hf_socket_type_fluor4.label,
        constructed_value: true
      });
    }

    var hf_bulb_type1_fluorescent = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_bulb_type1_fluorescent';
    });

    if (hf_bulb_type1_fluorescent !== null && hf_bulb_type1_fluorescent !== void 0 && (_hf_bulb_type1_fluore = hf_bulb_type1_fluorescent.selected_attribute_options) !== null && _hf_bulb_type1_fluore !== void 0 && (_hf_bulb_type1_fluore2 = _hf_bulb_type1_fluore.attribute_option[0]) !== null && _hf_bulb_type1_fluore2 !== void 0 && _hf_bulb_type1_fluore2.label) {
      var _hf_bulb_type1_fluore3, _hf_bulb_type1_fluore4;

      specValues.push({
        label: 'Bulb',
        value: (_hf_bulb_type1_fluore3 = hf_bulb_type1_fluorescent.selected_attribute_options) === null || _hf_bulb_type1_fluore3 === void 0 ? void 0 : (_hf_bulb_type1_fluore4 = _hf_bulb_type1_fluore3.attribute_option[0]) === null || _hf_bulb_type1_fluore4 === void 0 ? void 0 : _hf_bulb_type1_fluore4.label,
        constructed_value: true
      });
    }

    var hf_voltage_fluorescent = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_voltage_fluorescent';
    });

    if (hf_voltage_fluorescent !== null && hf_voltage_fluorescent !== void 0 && (_hf_voltage_fluoresce = hf_voltage_fluorescent.selected_attribute_options) !== null && _hf_voltage_fluoresce !== void 0 && (_hf_voltage_fluoresce2 = _hf_voltage_fluoresce.attribute_option[0]) !== null && _hf_voltage_fluoresce2 !== void 0 && _hf_voltage_fluoresce2.label) {
      var _hf_voltage_fluoresce3, _hf_voltage_fluoresce4;

      specValues.push({
        label: 'Voltage',
        value: (_hf_voltage_fluoresce3 = hf_voltage_fluorescent.selected_attribute_options) === null || _hf_voltage_fluoresce3 === void 0 ? void 0 : (_hf_voltage_fluoresce4 = _hf_voltage_fluoresce3.attribute_option[0]) === null || _hf_voltage_fluoresce4 === void 0 ? void 0 : _hf_voltage_fluoresce4.label,
        constructed_value: true
      });
    }

    var hf_socket_qpa1_fluorescent = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_socket_qpa1_fluorescent';
    });

    if (hf_socket_qpa1_fluorescent !== null && hf_socket_qpa1_fluorescent !== void 0 && (_hf_socket_qpa1_fluor = hf_socket_qpa1_fluorescent.selected_attribute_options) !== null && _hf_socket_qpa1_fluor !== void 0 && (_hf_socket_qpa1_fluor2 = _hf_socket_qpa1_fluor.attribute_option[0]) !== null && _hf_socket_qpa1_fluor2 !== void 0 && _hf_socket_qpa1_fluor2.label) {
      var _hf_bulbincluded_fluo, _hf_bulbincluded_fluo2, _hf_socket_qpa1_fluor3, _hf_socket_qpa1_fluor4, _hf_socket_qpa1_fluor5, _hf_socket_qpa1_fluor6;

      var hf_bulbincluded_fluorescent = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
        return attr.attribute_metadata.code == 'hf_bulbincluded_fluorescent';
      });
      var hfSocketBulbsattrVal = hf_bulbincluded_fluorescent !== null && hf_bulbincluded_fluorescent !== void 0 && (_hf_bulbincluded_fluo = hf_bulbincluded_fluorescent.selected_attribute_options) !== null && _hf_bulbincluded_fluo !== void 0 && (_hf_bulbincluded_fluo2 = _hf_bulbincluded_fluo.attribute_option[0]) !== null && _hf_bulbincluded_fluo2 !== void 0 && _hf_bulbincluded_fluo2.label ? ((_hf_socket_qpa1_fluor3 = hf_socket_qpa1_fluorescent.selected_attribute_options) === null || _hf_socket_qpa1_fluor3 === void 0 ? void 0 : (_hf_socket_qpa1_fluor4 = _hf_socket_qpa1_fluor3.attribute_option[0]) === null || _hf_socket_qpa1_fluor4 === void 0 ? void 0 : _hf_socket_qpa1_fluor4.label) + ' (included)' : ((_hf_socket_qpa1_fluor5 = hf_socket_qpa1_fluorescent.selected_attribute_options) === null || _hf_socket_qpa1_fluor5 === void 0 ? void 0 : (_hf_socket_qpa1_fluor6 = _hf_socket_qpa1_fluor5.attribute_option[0]) === null || _hf_socket_qpa1_fluor6 === void 0 ? void 0 : _hf_socket_qpa1_fluor6.label) + ' (not included)';
      specValues.push({
        label: 'Number of Bulbs',
        value: hfSocketBulbsattrVal,
        constructed_value: true
      });
    }
  } else {
    var _hfLamping$selected_a3, _hfLamping$selected_a4, _hfLamping$selected_a5, _hfLamping$selected_a6, _hfBulbType1$selected, _hfBulbType1$selected2, _hfLed$selected_attri, _hfLed$selected_attri2, _hfBulbType1$selected3, _hfBulbType1$selected4, _hfBulbWatt1$selected, _hfBulbWatt1$selected2, _hfBulbType1$selected5, _hfBulbType1$selected6, _hfBulbWatt1$selected3, _hfBulbWatt1$selected4, _hfBulbType1$selected7, _hfBulbType1$selected8, _hfBulbWatt1$selected5, _hfBulbWatt1$selected6, _hfBulbWatt1$selected7, _hfBulbWatt1$selected8;

    var hfLedType = (hfLamping === null || hfLamping === void 0 ? void 0 : (_hfLamping$selected_a3 = hfLamping.selected_attribute_options) === null || _hfLamping$selected_a3 === void 0 ? void 0 : (_hfLamping$selected_a4 = _hfLamping$selected_a3.attribute_option[0]) === null || _hfLamping$selected_a4 === void 0 ? void 0 : _hfLamping$selected_a4.label) == 'SKT/FLU' ? null : (hfLamping === null || hfLamping === void 0 ? void 0 : (_hfLamping$selected_a5 = hfLamping.selected_attribute_options) === null || _hfLamping$selected_a5 === void 0 ? void 0 : (_hfLamping$selected_a6 = _hfLamping$selected_a5.attribute_option[0]) === null || _hfLamping$selected_a6 === void 0 ? void 0 : _hfLamping$selected_a6.label) == 'LED' && hfBulbType1 !== null && hfBulbType1 !== void 0 && (_hfBulbType1$selected = hfBulbType1.selected_attribute_options) !== null && _hfBulbType1$selected !== void 0 && (_hfBulbType1$selected2 = _hfBulbType1$selected.attribute_option[0]) !== null && _hfBulbType1$selected2 !== void 0 && _hfBulbType1$selected2.label.includes('GU24') ? {
      label: 'Lamping',
      value: 'Retrofit',
      constructed_value: true
    } : hfLed !== null && hfLed !== void 0 && (_hfLed$selected_attri = hfLed.selected_attribute_options) !== null && _hfLed$selected_attri !== void 0 && (_hfLed$selected_attri2 = _hfLed$selected_attri.attribute_option[0]) !== null && _hfLed$selected_attri2 !== void 0 && _hfLed$selected_attri2.label ? {
      label: 'Lamping',
      value: 'Dedicated',
      constructed_value: true
    } : null;
    if (hfLedType) specValues.push(hfLedType);
    specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_socket_type';
    }));
    var bulb = {
      label: 'Bulb',
      value: hfBulbType1 !== null && hfBulbType1 !== void 0 && (_hfBulbType1$selected3 = hfBulbType1.selected_attribute_options) !== null && _hfBulbType1$selected3 !== void 0 && (_hfBulbType1$selected4 = _hfBulbType1$selected3.attribute_option[0]) !== null && _hfBulbType1$selected4 !== void 0 && _hfBulbType1$selected4.label ? hfBulbWatt1 !== null && hfBulbWatt1 !== void 0 && (_hfBulbWatt1$selected = hfBulbWatt1.selected_attribute_options) !== null && _hfBulbWatt1$selected !== void 0 && (_hfBulbWatt1$selected2 = _hfBulbWatt1$selected.attribute_option[0]) !== null && _hfBulbWatt1$selected2 !== void 0 && _hfBulbWatt1$selected2.label ? (hfBulbType1 === null || hfBulbType1 === void 0 ? void 0 : (_hfBulbType1$selected5 = hfBulbType1.selected_attribute_options) === null || _hfBulbType1$selected5 === void 0 ? void 0 : (_hfBulbType1$selected6 = _hfBulbType1$selected5.attribute_option[0]) === null || _hfBulbType1$selected6 === void 0 ? void 0 : _hfBulbType1$selected6.label) + ', ' + (hfBulbWatt1 === null || hfBulbWatt1 === void 0 ? void 0 : (_hfBulbWatt1$selected3 = hfBulbWatt1.selected_attribute_options) === null || _hfBulbWatt1$selected3 === void 0 ? void 0 : (_hfBulbWatt1$selected4 = _hfBulbWatt1$selected3.attribute_option[0]) === null || _hfBulbWatt1$selected4 === void 0 ? void 0 : _hfBulbWatt1$selected4.label) + ' Max' : hfBulbType1 === null || hfBulbType1 === void 0 ? void 0 : (_hfBulbType1$selected7 = hfBulbType1.selected_attribute_options) === null || _hfBulbType1$selected7 === void 0 ? void 0 : (_hfBulbType1$selected8 = _hfBulbType1$selected7.attribute_option[0]) === null || _hfBulbType1$selected8 === void 0 ? void 0 : _hfBulbType1$selected8.label : hfBulbWatt1 !== null && hfBulbWatt1 !== void 0 && (_hfBulbWatt1$selected5 = hfBulbWatt1.selected_attribute_options) !== null && _hfBulbWatt1$selected5 !== void 0 && (_hfBulbWatt1$selected6 = _hfBulbWatt1$selected5.attribute_option[0]) !== null && _hfBulbWatt1$selected6 !== void 0 && _hfBulbWatt1$selected6.label ? (hfBulbWatt1 === null || hfBulbWatt1 === void 0 ? void 0 : (_hfBulbWatt1$selected7 = hfBulbWatt1.selected_attribute_options) === null || _hfBulbWatt1$selected7 === void 0 ? void 0 : (_hfBulbWatt1$selected8 = _hfBulbWatt1$selected7.attribute_option[0]) === null || _hfBulbWatt1$selected8 === void 0 ? void 0 : _hfBulbWatt1$selected8.label) + ' Max' : null,
      constructed_value: true
    };
    if (bulb.value) specValues.push(bulb);
    var socketQPA1 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_socket_qpa1';
    });
    var socketQPA2 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_socket_qpa2';
    });
    var hfBulbIncluded = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_bulbincluded';
    });

    if (socketQPA1 || socketQPA2) {
      var _socketQPA1$selected_, _socketQPA1$selected_2, _socketQPA1$selected_3, _socketQPA1$selected_4, _socketQPA2$selected_, _socketQPA2$selected_2, _socketQPA2$selected_3, _socketQPA2$selected_4, _hfBulbIncluded$selec, _hfBulbIncluded$selec2;

      var sock1 = isNaN(parseInt(socketQPA1 === null || socketQPA1 === void 0 ? void 0 : (_socketQPA1$selected_ = socketQPA1.selected_attribute_options) === null || _socketQPA1$selected_ === void 0 ? void 0 : (_socketQPA1$selected_2 = _socketQPA1$selected_.attribute_option[0]) === null || _socketQPA1$selected_2 === void 0 ? void 0 : _socketQPA1$selected_2.label)) ? 0 : parseInt(socketQPA1 === null || socketQPA1 === void 0 ? void 0 : (_socketQPA1$selected_3 = socketQPA1.selected_attribute_options) === null || _socketQPA1$selected_3 === void 0 ? void 0 : (_socketQPA1$selected_4 = _socketQPA1$selected_3.attribute_option[0]) === null || _socketQPA1$selected_4 === void 0 ? void 0 : _socketQPA1$selected_4.label);
      var sock2 = isNaN(parseInt(socketQPA2 === null || socketQPA2 === void 0 ? void 0 : (_socketQPA2$selected_ = socketQPA2.selected_attribute_options) === null || _socketQPA2$selected_ === void 0 ? void 0 : (_socketQPA2$selected_2 = _socketQPA2$selected_.attribute_option[0]) === null || _socketQPA2$selected_2 === void 0 ? void 0 : _socketQPA2$selected_2.label)) ? 0 : parseInt(socketQPA2 === null || socketQPA2 === void 0 ? void 0 : (_socketQPA2$selected_3 = socketQPA2.selected_attribute_options) === null || _socketQPA2$selected_3 === void 0 ? void 0 : (_socketQPA2$selected_4 = _socketQPA2$selected_3.attribute_option[0]) === null || _socketQPA2$selected_4 === void 0 ? void 0 : _socketQPA2$selected_4.label);
      var additionalText = (hfBulbIncluded === null || hfBulbIncluded === void 0 ? void 0 : (_hfBulbIncluded$selec = hfBulbIncluded.selected_attribute_options) === null || _hfBulbIncluded$selec === void 0 ? void 0 : (_hfBulbIncluded$selec2 = _hfBulbIncluded$selec.attribute_option[0]) === null || _hfBulbIncluded$selec2 === void 0 ? void 0 : _hfBulbIncluded$selec2.label) === 'Yes' ? ' (included)' : ' (not included)';
      var value = sock1 + sock2;

      if (value > 0) {
        specValues.push({
          label: 'Number of Bulbs',
          value: value + additionalText,
          constructed_value: true
        });
      }
    }

    specValues.push(hfLed);
    specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_delivered_lumens';
    }));
    specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_cct';
    }));
    specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_cri';
    }));
    specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_input';
    }));
    specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_dimming';
    }));
    specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_voltage';
    }));
  }

  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_location_rating_ul';
  }));
  specValues.push(customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_safety_rating';
  }));

  if (hf_sloped_ceiling_code !== null && hf_sloped_ceiling_code !== void 0 && (_hf_sloped_ceiling_co = hf_sloped_ceiling_code.selected_attribute_options) !== null && _hf_sloped_ceiling_co !== void 0 && (_hf_sloped_ceiling_co2 = _hf_sloped_ceiling_co.attribute_option[0]) !== null && _hf_sloped_ceiling_co2 !== void 0 && _hf_sloped_ceiling_co2.label) {
    var _hf_sloped_ceiling_co3, _hf_sloped_ceiling_co4, _hf_sloped_ceiling_co5;

    var ceiling_value = {
      label: hf_sloped_ceiling_code === null || hf_sloped_ceiling_code === void 0 ? void 0 : (_hf_sloped_ceiling_co3 = hf_sloped_ceiling_code.attribute_metadata) === null || _hf_sloped_ceiling_co3 === void 0 ? void 0 : _hf_sloped_ceiling_co3.label,
      value: hf_sloped_ceiling_code === null || hf_sloped_ceiling_code === void 0 ? void 0 : (_hf_sloped_ceiling_co4 = hf_sloped_ceiling_code.selected_attribute_options) === null || _hf_sloped_ceiling_co4 === void 0 ? void 0 : (_hf_sloped_ceiling_co5 = _hf_sloped_ceiling_co4.attribute_option[0]) === null || _hf_sloped_ceiling_co5 === void 0 ? void 0 : _hf_sloped_ceiling_co5.label,
      constructed_value: true
    };
    specValues.push(ceiling_value);
  }

  var joistCaution = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_directto_joist_caution';
  });
  var weightAttr = filteredSimpleOnGrouped ? {
    label: 'Product Weight',
    value: (filteredSimpleOnGrouped === null || filteredSimpleOnGrouped === void 0 ? void 0 : filteredSimpleOnGrouped.weight) + ' lbs',
    constructed_value: true
  } : weight ? {
    label: 'Product Weight',
    value: weight + ' lbs',
    constructed_value: true
  } : null;
  var hf_pipe_length_min = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_pipe_length_min';
  });
  var hf_pipe_length_max = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_pipe_length_max';
  });
  var overallHeight = filteredSimpleOnGrouped !== null && filteredSimpleOnGrouped !== void 0 && filteredSimpleOnGrouped.hf_pipe_length_min || filteredSimpleOnGrouped !== null && filteredSimpleOnGrouped !== void 0 && filteredSimpleOnGrouped.hf_pipe_length_max ? {
    label: 'Overall Height',
    value: (filteredSimpleOnGrouped === null || filteredSimpleOnGrouped === void 0 ? void 0 : filteredSimpleOnGrouped.hf_pipe_length_min) + '" to ' + (filteredSimpleOnGrouped === null || filteredSimpleOnGrouped === void 0 ? void 0 : filteredSimpleOnGrouped.hf_pipe_length_max) + '"',
    constructed_value: true
  } : hf_pipe_length_min && hf_pipe_length_min !== null && hf_pipe_length_min !== void 0 && (_hf_pipe_length_min$e = hf_pipe_length_min.entered_attribute_value) !== null && _hf_pipe_length_min$e !== void 0 && _hf_pipe_length_min$e.value && hf_pipe_length_max && hf_pipe_length_max !== null && hf_pipe_length_max !== void 0 && (_hf_pipe_length_max$e = hf_pipe_length_max.entered_attribute_value) !== null && _hf_pipe_length_max$e !== void 0 && _hf_pipe_length_max$e.value ? {
    label: 'Overall Height',
    value: hf_pipe_length_min.entered_attribute_value.value + '" to ' + hf_pipe_length_max.entered_attribute_value.value + '"',
    constructed_value: true
  } : null;
  var useableWire = filteredSimpleOnGrouped === null || filteredSimpleOnGrouped === void 0 ? void 0 : (_filteredSimpleOnGrou = filteredSimpleOnGrouped.custom_attributes) === null || _filteredSimpleOnGrou === void 0 ? void 0 : _filteredSimpleOnGrou.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_useable_wire';
  });
  var hf_backplate_width = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_backplate_width';
  });
  var hf_backplate_height = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_backplate_height';
  });
  var backPlate = hf_backplate_width && hf_backplate_width !== null && hf_backplate_width !== void 0 && (_hf_backplate_width$e = hf_backplate_width.entered_attribute_value) !== null && _hf_backplate_width$e !== void 0 && _hf_backplate_width$e.value && hf_backplate_height && hf_backplate_height !== null && hf_backplate_height !== void 0 && (_hf_backplate_height$ = hf_backplate_height.entered_attribute_value) !== null && _hf_backplate_height$ !== void 0 && _hf_backplate_height$.value ? {
    label: 'Backplate',
    value: hf_backplate_height.entered_attribute_value.value + '" x ' + hf_backplate_width.entered_attribute_value.value + '"',
    constructed_value: true
  } : null;
  var hf_box_weight1 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_weight1';
  });
  var hf_box_weight2 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_weight2';
  });
  var hf_box_weight3 = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_box_weight3';
  });
  var boxWeight = hf_box_weight1 && hf_box_weight1 !== null && hf_box_weight1 !== void 0 && (_hf_box_weight1$enter = hf_box_weight1.entered_attribute_value) !== null && _hf_box_weight1$enter !== void 0 && _hf_box_weight1$enter.value || hf_box_weight2 && hf_box_weight2 !== null && hf_box_weight2 !== void 0 && (_hf_box_weight2$enter = hf_box_weight2.entered_attribute_value) !== null && _hf_box_weight2$enter !== void 0 && _hf_box_weight2$enter.value || hf_box_weight3 && hf_box_weight3 !== null && hf_box_weight3 !== void 0 && (_hf_box_weight3$enter = hf_box_weight3.entered_attribute_value) !== null && _hf_box_weight3$enter !== void 0 && _hf_box_weight3$enter.value ? {
    label: 'Packed weight',
    value: (isNaN(parseFloat(hf_box_weight1 === null || hf_box_weight1 === void 0 ? void 0 : (_hf_box_weight1$enter2 = hf_box_weight1.entered_attribute_value) === null || _hf_box_weight1$enter2 === void 0 ? void 0 : _hf_box_weight1$enter2.value)) ? 0 : parseFloat(hf_box_weight1 === null || hf_box_weight1 === void 0 ? void 0 : (_hf_box_weight1$enter3 = hf_box_weight1.entered_attribute_value) === null || _hf_box_weight1$enter3 === void 0 ? void 0 : _hf_box_weight1$enter3.value)) + (isNaN(parseFloat(hf_box_weight2 === null || hf_box_weight2 === void 0 ? void 0 : (_hf_box_weight2$enter2 = hf_box_weight2.entered_attribute_value) === null || _hf_box_weight2$enter2 === void 0 ? void 0 : _hf_box_weight2$enter2.value)) ? 0 : parseFloat(hf_box_weight2 === null || hf_box_weight2 === void 0 ? void 0 : (_hf_box_weight2$enter3 = hf_box_weight2.entered_attribute_value) === null || _hf_box_weight2$enter3 === void 0 ? void 0 : _hf_box_weight2$enter3.value)) + (isNaN(parseFloat(hf_box_weight3 === null || hf_box_weight3 === void 0 ? void 0 : (_hf_box_weight3$enter2 = hf_box_weight3.entered_attribute_value) === null || _hf_box_weight3$enter2 === void 0 ? void 0 : _hf_box_weight3$enter2.value)) ? 0 : parseFloat(hf_box_weight3 === null || hf_box_weight3 === void 0 ? void 0 : (_hf_box_weight3$enter3 = hf_box_weight3.entered_attribute_value) === null || _hf_box_weight3$enter3 === void 0 ? void 0 : _hf_box_weight3$enter3.value)) + ' lbs',
    constructed_value: true
  } : null;
  var diameter = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_diameter';
  });
  var relativeDimensions = diameter !== null && diameter !== void 0 && (_diameter$entered_att = diameter.entered_attribute_value) !== null && _diameter$entered_att !== void 0 && _diameter$entered_att.value ? [customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_height';
  }), diameter] : [customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_width';
  }), customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_height';
  }), customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_depth_length';
  })];
  var dimValues = [].concat(relativeDimensions, [weightAttr, // 'Footpring [BaseDim]', this attr doesn't exist
  overallHeight, backPlate, customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_mounting_heighthorizontal';
  }), customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_canopy_dim_plate';
  }), useableWire || (customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_useable_wire';
  })), customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
    return attr.attribute_metadata.code == 'hf_chain_included';
  }) // boxWeight, // Removed, as per requested by client in #HF-1859
  // customAttributes?.find(attr => attr.attribute_metadata.code == 'hf_dim_weight')
  ]);
  var inchAttributes = ['hf_height', 'hf_width', 'hf_depth_length', 'hf_mounting_heightvertical', 'hf_mounting_heighthorizontal', 'hf_diameter'];
  var hfMounting = useMemo(function () {
    var _mounting$attribute_m, _mounting$selected_at, _mounting$selected_at2, _mounting$selected_at3;

    var mounting = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_mounting_heightvertical';
    });
    if (!mounting) return React.createElement(React.Fragment, null);
    return React.createElement("div", {
      className: "flex"
    }, React.createElement("p", {
      className: "font-bold flex-[50%]"
    }, mounting === null || mounting === void 0 ? void 0 : (_mounting$attribute_m = mounting.attribute_metadata) === null || _mounting$attribute_m === void 0 ? void 0 : _mounting$attribute_m.label), React.createElement("p", {
      className: 'flex-[50%]'
    }, mounting === null || mounting === void 0 ? void 0 : (_mounting$selected_at = mounting.selected_attribute_options) === null || _mounting$selected_at === void 0 ? void 0 : (_mounting$selected_at2 = _mounting$selected_at.attribute_option) === null || _mounting$selected_at2 === void 0 ? void 0 : (_mounting$selected_at3 = _mounting$selected_at2.map(function (item) {
      return item.label;
    })) === null || _mounting$selected_at3 === void 0 ? void 0 : _mounting$selected_at3.join(', ')));
  }, [customAttributes]);
  var hfMountingDirection = useMemo(function () {
    var _mountingDirection$se, _mountingDirection$se2, _mountingDirection$se3, _mountingDirection$at;

    var mountingDirection = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.find(function (attr) {
      return attr.attribute_metadata.code == 'hf_mounting_direction';
    });
    var mountingDirectionValues = mountingDirection === null || mountingDirection === void 0 ? void 0 : (_mountingDirection$se = mountingDirection.selected_attribute_options) === null || _mountingDirection$se === void 0 ? void 0 : (_mountingDirection$se2 = _mountingDirection$se.attribute_option) === null || _mountingDirection$se2 === void 0 ? void 0 : (_mountingDirection$se3 = _mountingDirection$se2.map(function (option) {
      return option.label;
    })) === null || _mountingDirection$se3 === void 0 ? void 0 : _mountingDirection$se3.join(', ');
    if (!mountingDirection) return React.createElement(React.Fragment, null);
    return React.createElement("div", {
      className: "flex"
    }, React.createElement("p", {
      className: "font-bold flex-[50%]"
    }, mountingDirection === null || mountingDirection === void 0 ? void 0 : (_mountingDirection$at = mountingDirection.attribute_metadata) === null || _mountingDirection$at === void 0 ? void 0 : _mountingDirection$at.label), React.createElement("p", {
      className: 'flex-[50%]'
    }, mountingDirectionValues));
  }, [customAttributes]);
  var dimensionContent = React.createElement("div", {
    className: "mr-2.5 mt-4 md_mt-0"
  }, !props.isPDF && joistCaution && (joistCaution === null || joistCaution === void 0 ? void 0 : (_joistCaution$selecte = joistCaution.selected_attribute_options) === null || _joistCaution$selecte === void 0 ? void 0 : (_joistCaution$selecte2 = _joistCaution$selecte.attribute_option[0]) === null || _joistCaution$selecte2 === void 0 ? void 0 : _joistCaution$selecte2.label) == 'Yes' && React.createElement("div", {
    className: "flex flex-col mb-5"
  }, React.createElement("p", null, React.createElement("span", {
    className: "font-bold inline"
  }, "Caution!"), " The weight of this fixture requires direct-to-joist, beam or overlay attachment independent of the electrical joist box.")), React.createElement("div", {
    className: "flex flex-col"
  }, props.isPDF ? React.createElement("p", {
    className: "font-bold subheading "
  }, "Dimensions") : null, dimValues.map(function (attribute, idx) {
    if (attribute) {
      var _attribute$entered_at, _attrValue, _attrValue$split, _attrValue2;

      if (attribute.hasOwnProperty('constructed_value')) {
        var _attribute$value;

        var attributeValue = attribute.value;

        if (!inches && !((_attribute$value = attribute.value) !== null && _attribute$value !== void 0 && _attribute$value.includes('lbs'))) {
          var _attributeValue, _attributeValue$repla, _attributeValueSplit, _attributeValueSplit2;

          var attributeValueSplit = (_attributeValue = attributeValue) === null || _attributeValue === void 0 ? void 0 : (_attributeValue$repla = _attributeValue.replaceAll('"', '')) === null || _attributeValue$repla === void 0 ? void 0 : _attributeValue$repla.split('x');
          attributeValueSplit = (_attributeValueSplit = attributeValueSplit) === null || _attributeValueSplit === void 0 ? void 0 : _attributeValueSplit.map(function (val) {
            return (parseFloat(val) * 25.4).toFixed(2) + ' mm';
          });
          attributeValue = (_attributeValueSplit2 = attributeValueSplit) === null || _attributeValueSplit2 === void 0 ? void 0 : _attributeValueSplit2.join(' x ');
        }

        return React.createElement(DimensionItem, {
          measure: attribute.label,
          value: attributeValue,
          key: idx,
          isPdf: props.isPDF
        });
      }

      var attrValue = (_attribute$entered_at = attribute.entered_attribute_value) === null || _attribute$entered_at === void 0 ? void 0 : _attribute$entered_at.value;
      if (!attrValue && attribute.selected_attribute_options.attribute_option.length) // try with selected value
        attrValue = attribute.selected_attribute_options.attribute_option.map(function (item) {
          return item.label;
        }).join(', ');
      if (inchAttributes.includes(attribute.attribute_metadata.code)) attrValue = inches ? parseFloat(attrValue) + '"' : parseFloat(attrValue);
      if (attribute.attribute_metadata.code == 'hf_dim_weight') attrValue = parseFloat(attrValue) + ' lbs';

      if (typeof attrValue === 'string' && ((_attrValue = attrValue) === null || _attrValue === void 0 ? void 0 : (_attrValue$split = _attrValue.split(' ')) === null || _attrValue$split === void 0 ? void 0 : _attrValue$split.length) > 1 && (_attrValue2 = attrValue) !== null && _attrValue2 !== void 0 && _attrValue2.includes('"')) {
        if (!inches) {
          var _attrValue3, _attrValue3$split, _attrValue3$split$map;

          attrValue = (_attrValue3 = attrValue) === null || _attrValue3 === void 0 ? void 0 : (_attrValue3$split = _attrValue3.split(' ')) === null || _attrValue3$split === void 0 ? void 0 : (_attrValue3$split$map = _attrValue3$split.map(function (el) {
            var _el, _el2;

            if ((_el = el) !== null && _el !== void 0 && _el.includes('"')) el = (parseFloat((_el2 = el) === null || _el2 === void 0 ? void 0 : _el2.replace('"', '')) * 25.4).toFixed(2) + ' mm';
            return el;
          })) === null || _attrValue3$split$map === void 0 ? void 0 : _attrValue3$split$map.join(' ');
        }
      }

      return React.createElement(DimensionItem, {
        measure: attribute.attribute_metadata.label,
        value: !inches && typeof attrValue === 'number' ? (Number(attrValue) * 25.4).toFixed(2) + ' mm' : attrValue,
        key: attribute.attribute_metadata.uid,
        isPdf: props.isPDF
      });
    }
  }), hfMounting, hfMountingDirection, props !== null && props !== void 0 && props.isPDF ? null : React.createElement("div", {
    className: "mt-6"
  }, React.createElement("div", {
    className: "flex flex-col"
  }, React.createElement(Link, {
    target: "_blank",
    to: "/about/lifetime-limited-warranty",
    className: "underline uppercase text-bronze font-bold mt-5 flex items-center",
    "aria-label": "Go to Lifetime Limited Warranty page"
  }, "LIFETIME LIMITED WARRANTY", React.createElement("span", {
    className: classes.quickIcon
  }, React.createElement(QuickLinkIcon, null)))))));
  var additionalFeatureAttributesPool = ['hf_option1', 'hf_lamping', 'hf_adacompliant', 'hf_sloped_ceiling', 'hf_dark_sky_friendly', 'hf_patent', // 'Title 24 Compliant [If Title24 value positive]',
  // 'Title 20 Compliant [If Title20 value positive]',
  // 'hf_overall_height',
  // 'hf_cable_hung', //'Includes adjustable cable and canopy kit [If CableHung value of “1”]',
  // 'hf_down_rod_count', //'Includes adjustable stem and canopy kit [If DownrodCount value positive]',
  'hf_turtle_friendly' // not present yet in data
  ];
  var additionalFeatureAttributes = configCustomAttributes === null || configCustomAttributes === void 0 ? void 0 : configCustomAttributes.filter(function (attr) {
    var _product$configurable;

    return additionalFeatureAttributesPool.includes(attr.attribute_metadata.code) && !((_product$configurable = product.configurable_options) !== null && _product$configurable !== void 0 && _product$configurable.find(function (option) {
      return option.attribute_code == attr.attribute_metadata.code;
    }));
  }).filter(function (attr) {
    var _attr$selected_attrib, _attr$selected_attrib2, _attr$selected_attrib3, _attr$selected_attrib4, _attr$entered_attribu, _attr$entered_attribu2;

    return !(attr.attribute_metadata.code == 'hf_lamping' && attr.selected_attribute_options.attribute_option[0].label.includes('None') || attr.attribute_metadata.code == 'hf_adacompliant' && ((_attr$selected_attrib = attr.selected_attribute_options.attribute_option[0]) === null || _attr$selected_attrib === void 0 ? void 0 : _attr$selected_attrib.label.toLowerCase()) == 'no' || attr.attribute_metadata.code == 'hf_dark_sky_friendly' && ((_attr$selected_attrib2 = attr.selected_attribute_options.attribute_option[0]) === null || _attr$selected_attrib2 === void 0 ? void 0 : _attr$selected_attrib2.label.toLowerCase()) == 'no' || attr.attribute_metadata.code == 'hf_sloped_ceiling' && ((_attr$selected_attrib3 = attr.selected_attribute_options.attribute_option[0]) === null || _attr$selected_attrib3 === void 0 ? void 0 : _attr$selected_attrib3.label.toLowerCase()) == 'no' || attr.attribute_metadata.code == 'hf_sloped_ceiling' && ((_attr$selected_attrib4 = attr.selected_attribute_options.attribute_option[0]) === null || _attr$selected_attrib4 === void 0 ? void 0 : _attr$selected_attrib4.label.toLowerCase()) == 'no (0)' || attr.attribute_metadata.code == 'hf_patent' && ((_attr$entered_attribu = attr.entered_attribute_value) === null || _attr$entered_attribu === void 0 ? void 0 : (_attr$entered_attribu2 = _attr$entered_attribu.value) === null || _attr$entered_attribu2 === void 0 ? void 0 : _attr$entered_attribu2.toLowerCase()) == 'no');
  });
  var fluorescentAttributes = '';
  var featuresContent = !isOutletProduct && additionalFeatureAttributes !== null && additionalFeatureAttributes !== void 0 && additionalFeatureAttributes.length ? React.createElement("div", {
    className: "mt-4 md_mt-0 mb-10"
  }, (props === null || props === void 0 ? void 0 : props.isPDF) && React.createElement(SectionTitle, {
    title: "Features"
  }), React.createElement("ul", {
    className: classes.feturesList
  }, additionalFeatureAttributes === null || additionalFeatureAttributes === void 0 ? void 0 : additionalFeatureAttributes.map(function (item, idx) {
    return React.createElement(AdditionalFeatureItem, {
      key: idx,
      data: item
    });
  }))) : null;
  useEffect(function () {
    if (!isOutletProduct && additionalFeatureAttributes !== null && additionalFeatureAttributes !== void 0 && additionalFeatureAttributes.length && !(tabs !== null && tabs !== void 0 && tabs.includes('Features'))) {
      if (tabs !== null && tabs !== void 0 && tabs.includes('Shipping & Facts')) {
        tabs[2] = 'Features';
        setTabs(tabs);
      } else setTabs([].concat(_toConsumableArray(tabs), ['Features']));
    }
  }, [isOutletProduct, additionalFeatureAttributes, tabs]);
  useEffect(function () {
    return isCustomerServiceTeam && !(tabs !== null && tabs !== void 0 && tabs.includes('Shipping & Facts')) && setTabs([].concat(_toConsumableArray(tabs), ['Shipping & Facts']));
  }, [isCustomerServiceTeam, tabs]);
  useEffect(function () {
    var _productDetails$short;

    if (productDetails !== null && productDetails !== void 0 && (_productDetails$short = productDetails.short_description) !== null && _productDetails$short !== void 0 && _productDetails$short.html) setTabs([].concat(_toConsumableArray(tabs), ['Features']));
  }, []);
  var detailsContent = React.createElement("div", null, React.createElement("div", {
    className: "flex flex-col mt-4 md_mt-0"
  }, props.isPDF ? React.createElement("p", {
    className: "font-bold subheading mt-4"
  }, "Lamping Information") : null, React.createElement("p", {
    className: "font-bold  mt-4 bg-snowbound"
  }, "Lamping Spec"), specValues.map(function (specValue, idx) {
    if (!specValue) return null;
    if (!props.isPDF && (specValue === null || specValue === void 0 ? void 0 : specValue.label) === 'Sloped Ceiling') return null;

    if (specValue.hasOwnProperty('constructed_value')) {
      return React.createElement(DimensionItem, {
        key: idx,
        measure: specValue.label,
        value: specValue.value,
        isPdf: props.isPDF
      });
    }

    var attrValue = specValue.entered_attribute_value.value;

    if (!attrValue && specValue.selected_attribute_options.attribute_option.length) {
      // try with selected value
      attrValue = specValue.selected_attribute_options.attribute_option.map(function (item) {
        return item.label;
      }).join(', ');
    } // special cases/considerations


    if (specValue.attribute_metadata.code == 'hf_voltage') {
      attrValue = attrValue + 'V';
    }

    if (specValue.attribute_metadata.code == 'hf_safety_rating') {
      attrValue = attrValue + ' listed';
    }

    return React.createElement(DimensionItem, {
      key: idx,
      measure: specValue.attribute_metadata.label,
      value: attrValue,
      isPdf: props.isPDF
    });
  }), !props.isPDF && React.createElement(BulbRecommendation, {
    product: product,
    isPdf: props.isPDF
  })));

  if (props.isPDF) {
    return React.createElement("div", {
      className: classes.pdfContainer
    }, React.createElement("div", {
      className: "col-span-1"
    }, dimensionContent), React.createElement("div", {
      className: "col-span-1"
    }, detailsContent));
  }

  var features = React.createElement(React.Fragment, null, !isSmallDevice && React.createElement("p", {
    className: "font-bold text-base mb-4"
  }, "Features"), !props.isPDF && React.createElement("div", {
    className: "mb-4 mt-4 md_mt-0"
  }, React.createElement("div", {
    className: "text-bronze"
  }, React.createElement(RichContent, {
    html: productDetails.short_description.html
  }))), featuresContent);
  return React.createElement("div", {
    ref: ref,
    className: classes.root
  }, !isSmallDevice && React.createElement("div", {
    className: classes.tabs
  }, tabs === null || tabs === void 0 ? void 0 : (_tabs$filter = tabs.filter(function (tab) {
    var _specValues$filter;

    return !(specValues !== null && specValues !== void 0 && (_specValues$filter = specValues.filter(function (el) {
      return el;
    })) !== null && _specValues$filter !== void 0 && _specValues$filter.length) ? tab !== 'Lamping' : tab;
  })) === null || _tabs$filter === void 0 ? void 0 : _tabs$filter.map(function (tab) {
    return React.createElement("p", {
      onClick: function onClick() {
        return setActiveTab(tab);
      },
      className: activeTab === tab && classes.activeTab
    }, tab);
  })), React.createElement("div", {
    className: "grid"
  }, !(props !== null && props !== void 0 && props.isPDF) && !isSmallDevice ? fade ? React.createElement(React.Fragment, null) : React.createElement("div", {
    className: classes.activeContent
  }, activeTab === tabs[0] ? dimensionContent : activeTab === tabs[1] ? detailsContent : activeTab === 'Features' ? features : activeTab === 'Shipping & Facts' ? React.createElement(CSPortalDetails, {
    productDetails: productDetails,
    customAttributes: customAttributes,
    weight: weight,
    product: product,
    configCustomAttributes: configCustomAttributes,
    isOutletProduct: isOutletProduct
  }) : null) : isSmallDevice ? React.createElement("div", {
    className: classes.tabsMobile
  }, tabs === null || tabs === void 0 ? void 0 : (_tabs$filter2 = tabs.filter(function (tab) {
    var _specValues$filter2;

    return !(specValues !== null && specValues !== void 0 && (_specValues$filter2 = specValues.filter(function (el) {
      return el;
    })) !== null && _specValues$filter2 !== void 0 && _specValues$filter2.length) ? tab !== 'Lamping' : tab;
  })) === null || _tabs$filter2 === void 0 ? void 0 : _tabs$filter2.map(function (tab) {
    return React.createElement(Accordion, {
      classes: {
        wrapper: classes.accordionWrapper,
        title: classes.accordionTitle,
        closeIcon: classes.accordionCloseIcon
      },
      title: tab,
      content: tab === tabs[0] ? dimensionContent : tab === tabs[1] ? detailsContent : tab === 'Features' ? features : tab === 'Shipping & Facts' ? React.createElement(CSPortalDetails, {
        productDetails: productDetails,
        customAttributes: customAttributes,
        weight: weight,
        product: product,
        configCustomAttributes: configCustomAttributes,
        isOutletProduct: isOutletProduct
      }) : React.createElement(React.Fragment, null),
      openIcon: React.createElement("img", {
        src: openIcon,
        alt: "open-icon"
      }),
      closeIcon: React.createElement("img", {
        src: closeIcon,
        alt: "close-icon"
      })
    });
  })) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "col-span-1"
  }, dimensionContent), React.createElement("div", {
    className: "col-span-1"
  }, featuresContent, " ", detailsContent))), !isUserSignedIn && props !== null && props !== void 0 && props.isPDF ? React.createElement("div", {
    className: "flex flex-col items-center justify-center bg-snowbound py-12 mt-10 border-solid border border-bronze mb-40 px-2.5 md_px-0"
  }, React.createElement("h6", {
    className: "text-18 font-bold text-black leading-178 mb-4 md_mb-3"
  }, "Are you a professional?"), React.createElement("p", {
    className: "text-center md_text text-bronze"
  }, "Interested in gaining access to additional information and resources?"), React.createElement("div", {
    className: classes.btnWrapper
  }, React.createElement(Button, {
    classes: {
      content: classes.loginCreateBtn
    },
    priority: "low",
    onClick: function onClick() {
      return history.push('/sign-in');
    },
    "aria-label": "Login or create a web profile",
    fullWidth: true
  }, "LOGIN OR CREATE A WEB PROFILE"))) : null);
});
export default Specifications;